/* eslint-disable import/prefer-default-export */
import { FONT_FAMILY, EVENT_DT_FORMAT, TOOLTIP_LABEL_FORMAT } from '@utils/constants';
import moment from 'moment-timezone';
import { humanizeValue } from '../../utils';
import { humanize } from '@utils';

const colorSpan = (color) => `<span
  style="display:inline-block;
  margin-right:5px;
  width:9px;
  height:9px;
  background-color:${color}">
  </span>`;

const tooltipFormatter = (params, unit) => {
  let htmlString = `<span style="font-size:13px;display: block;">
      ${moment(params[0].axisValue).format(TOOLTIP_LABEL_FORMAT)}
    </span>`;

  const valueStr: string[] = [];
  params.forEach((newSeries, idx) => {
    const { humanizedNumber, humanizedUnit } = humanizeValue(newSeries.data[1], unit);
    valueStr.push(`
      <span style="display:inline-block;margin-right:5px;padding-right:5px;${idx === params.length - 1 ? '' : 'border-right: 1px solid #ddd;'}">
        ${colorSpan(newSeries.color)}  ${humanizedNumber || '0'} ${humanizedUnit || ''}
      </span>`);
  });
  htmlString += valueStr.join('');
  return `<div style="line-height:1.5;width:200px;overflow: hidden;">${htmlString}</div>`;
};

const axisColor = '#ccc';
const axisLabelColor = '#000';

export const createOptions = ({ seriesData, colors, filters, unit }) => {
  const options = {
    _viewType: 'timeseries',
    grid: {
      left: 40,
      right: 5,
      top: 10,
      bottom: 10,
      containLabel: false,
    },
    tooltip: {
      trigger: 'axis',
      // alwaysShowContent: true,
      // extraCssText: 'z-index: 999',
      // position: ['10%', '100%'],
      formatter: (params) => tooltipFormatter(params, unit),
      padding: 5,
      textStyle: {
        overflow: 'truncate',
        fontFamily: FONT_FAMILY,
        fontSize: 12,
      },
      // confine: true,
      appendToBody: true,
      className: 'echarts-tooltip',
    },
    xAxis: {
      id: 'time-axis',
      type: 'time',
      show: false,
      splitNumber: 1,
      axisLabel: {
        color: axisLabelColor,
        fontSize: 11,
        fontFamily: FONT_FAMILY,
        hideOverlap: true,
        showMinLabel: true,
        showMaxLabel: true,
        formatter(value) {
          return moment(value).format(EVENT_DT_FORMAT);
        },
      },
      splitLine: {
        show: false,
      },
      axisTick: {
        alignWithLabel: false,
        lineStyle: {
          color: axisColor,
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: axisColor,
        },
      },
    },
    yAxis: {
      id: 'value-axis',
      type: 'value',
      show: true,
      splitNumber: 2,
      nameLocation: 'middle',
      axisLabel: {
        color: axisLabelColor,
        fontSize: 11,
        fontFamily: FONT_FAMILY,
        hideOverlap: true,
        showMinLabel: true,
        showMaxLabel: true,
        formatter: (value) => humanize(value) + unit,
      },
      splitLine: {
        show: true,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: axisColor,
        },
      },
    },
    series: [],
  };
  const series: Array<{
    name: string;
    type: string;
    showSymbol: boolean;
    data: [number];
    color: string;
  }> = [];
  if (seriesData && seriesData.length > 0) {
    seriesData.forEach((data, i) => {
      series.push({
        name: filters[i],
        type: 'line',
        showSymbol: false,
        data,
        color: colors[i],
      });
    });
  }
  return { ...options, series };
};
